import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AppDispatch, StoreState } from '../../../store';
import { homeSelectors } from '../../../ducks/home/selectors';
import { homeActions } from '../../../ducks/home/actions';
import { PageRoutes } from '../../../constants/routes';

export const useHome = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const hotProperties = useSelector((state: StoreState) => homeSelectors.hotProperty(state));
  const homepageImage = useSelector((state: StoreState) => homeSelectors.image(state));

  useEffect(() => {
    dispatch(homeActions.hotPropertyies.started({}))
    // Only fetch homepage image if it's not already loaded
    if (!homepageImage) {
      dispatch(homeActions.homepageImage.started({}))
    }
  }, [dispatch, homepageImage]);

  const handleSearch = useCallback((values: any) => {
    // Navigate to the appropriate property page based on the selected type
    const targetRoute = values.type === 'commercial'
      ? PageRoutes.PROPERTY.COMMERCIAL
      : PageRoutes.PROPERTY.RESIDENTIAL;

    // Navigate with search data as state
    navigate(targetRoute, {
      state: {
        searchData: values,
        fromHome: true
      }
    });
  }, [navigate]);

  return {
    handleSearch,
    hotProperties,
    homepageImage
  };
};
